module.exports = __webpack_public_path__ + "static/media/KMH_5349.0af51e1d.jpg";